import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { SCENES } from "@/content/story";
import { scrollState } from "@/lib/scrollState";

export const ChapterRail = () => {
    const [active, setActive] = useState(-1);
    const { scrollYProgress } = useScroll();

    useMotionValueEvent(scrollYProgress, "change", (v) => {
        let idx = -1;
        SCENES.forEach((s, i) => {
            if (v >= s.p - 0.08) idx = i;
        });
        setActive(idx);
    });

    const go = (p) => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollState.lenis)
            scrollState.lenis.scrollTo(p * max, { duration: 2.6 });
        else window.scrollTo({ top: p * max, behavior: "smooth" });
    };

    return (
        <nav className="fixed left-6 top-1/2 z-20 hidden -translate-y-1/2 flex-col gap-5 lg:flex">
            {SCENES.map((s, i) => (
                <button
                    key={s.id}
                    data-testid={`chapter-nav-dot-${i}`}
                    onClick={() => go(s.p)}
                    className="group flex items-center gap-3"
                    aria-label={`Go to ${s.title}`}
                >
                    <span
                        className={`h-2.5 w-2.5 rounded-full border transition-all duration-500 ${
                            active === i
                                ? "scale-125 border-terracotta bg-terracotta"
                                : "border-inkfaint bg-transparent group-hover:border-terracotta"
                        }`}
                    />
                    <span
                        className={`font-mono text-[10px] uppercase tracking-[0.22em] transition-all duration-500 ${
                            active === i
                                ? "text-ink"
                                : "text-inkfaint opacity-0 group-hover:opacity-100"
                        }`}
                    >
                        {s.title}
                    </span>
                </button>
            ))}
        </nav>
    );
};

export default ChapterRail;
